var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicket1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.44444C1 2.98985 2.98985 1 5.44444 1H16.5556C19.0102 1 21 2.98985 21 5.44444C21 5.98773 20.6884 6.48288 20.1986 6.71798L19.7113 6.95192C17.993 7.7767 17.993 10.2233 19.7113 11.0481L20.1986 11.282C20.6884 11.5171 21 12.0123 21 12.5556C21 15.0102 19.0102 17 16.5556 17H5.44444C2.98985 17 1 15.0102 1 12.5556C1 12.0123 1.31157 11.5171 1.80135 11.282L2.28872 11.0481C4.00702 10.2233 4.00702 7.7767 2.28872 6.95192L1.80135 6.71798C1.31157 6.48288 1 5.98773 1 5.44444Z",
    stroke: "#77498F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1L13 17",
    stroke: "#77498F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeDasharray: "2 3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket1);
export default __webpack_public_path__ + "static/media/Ticket 1.f656906c2b1b3621c40932e208253060.svg";
export { ForwardRef as ReactComponent };